import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { en } from '@fullcalendar/core/internal-common';
import { apiEnpoints } from 'src/app/core/helpers/api-endpoints';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-view-quotation',
  templateUrl: './view-quotation.component.html',
  styleUrl: './view-quotation.component.scss'
})

export class ViewQuotationComponent implements OnInit{
  breadCrumbItems = [];
  baseImgUrl;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ApiService :ApiService,
  ) {
    this.baseImgUrl = environment.base_url;
  }
  poid : Number;
  quotationDetails: any;
  loggedUserName ='';
  nameSheetData = [];

  parts: string[] = [];
  selected: any = {};
  tableColumns: any[] = [];
  ordersizevalues: any[] = [];
  nameSheetDataList = [];
  tableColumnsList = [];
  ordersizevaluesList = [];

  ngOnInit(){
    this.poid = Number(this.route.snapshot.paramMap.get('poid'));
    this.quotationDetails = JSON.parse(sessionStorage.getItem('quotationData'));
    this.nameSheetDataList = [];
    this.tableColumnsList = [];
    this.ordersizevaluesList = [];

    // 🔁 Run the name sheet generation for each order
    this.quotationDetails.poDetails.purchasingOrders.forEach((order, index) => {
      this.getNameSheet(order, index);
    });
    var authUser = JSON.parse(localStorage.getItem("currentUser"));
    if(authUser){
      this.loggedUserName = authUser.profileName;
    }
  }

  getBillingAddress(id){

  }

  getDeliveryAddress(){

  }

  getTotalQuantity(purchasingOrderSizes){
    const totalQty = purchasingOrderSizes.reduce((sum, item) => sum + item.qty, 0);
    return totalQty;
  }

  // 🔹 Master function to process a single order
  getNameSheet(order: any, index: number) {
    if (!order.purchasingOrderSizeValues || order.purchasingOrderSizeValues.length === 0) return;

    this.nameSheetData = order.purchasingOrderSizeValues;

    // 1️⃣ Load unique parts and mark all fields
    this.loadPartsFromNameSheet();

    // 2️⃣ Generate column structure
    this.generateColumns();

    // 3️⃣ Build rows from data
    this.buildFromNameSheet();

    // Store separately for each order (to use easily in template)
    this.nameSheetDataList[index] = this.nameSheetData;
    this.tableColumnsList[index] = this.tableColumns;
    this.ordersizevaluesList[index] = this.ordersizevalues;

    console.log(this.nameSheetDataList);
    console.log(this.tableColumnsList)
  }


  // 🔹 Step 1: Load parts
  loadPartsFromNameSheet() {
    const partSet = new Set(this.nameSheetData.map(item => item.printPosition));
    this.parts = Array.from(partSet);
    this.selected = {};

    for (let part of this.parts) {
      this.selected[part] = { name: true, number: true };
    }
  }


  // 🔹 Step 2: Generate table column structure
  generateColumns() {
    this.tableColumns = [];

    for (let part of this.parts) {
      const fields: string[] = [];

      if (this.selected[part].name) fields.push('name');
      if (this.selected[part].number) fields.push('number');

      if (fields.length > 0) {
        this.tableColumns.push({ part, fields });
      }
    }
  }


  // 🔹 Step 3: Build rows from name sheet data
  buildFromNameSheet() {
    const grouped: any = {};
    const counters: Record<string, number> = {};

    for (let i = 0; i < this.nameSheetData.length; i++) {
      const item = this.nameSheetData[i];
      const nextItem = this.nameSheetData[i + 1];

      if (counters[item.size] === undefined) counters[item.size] = 0;
      const key = `${item.size}_${counters[item.size]}`;

      if (!grouped[key]) grouped[key] = { ssize: item.size };

      for (const field of ['name', 'number']) {
        const colKey = `${item.printPosition}_${field}`;
        grouped[key][colKey] = item[field] ?? '';
      }

      if (
        nextItem &&
        nextItem.size === item.size &&
        grouped[key][`${nextItem.printPosition}_name`] !== undefined
      ) {
        counters[item.size]++;
      }
    }

    this.ordersizevalues = Object.values(grouped);
  }

}
